// Locale is a unique combination of Country and Language
export enum CountryId {
  Australia = 10000013,
  Austria = 10000014,
  Belgium = 10000021,
  China = 10000045,
  'Czech Republic' = 10000060,
  Denmark = 10000061,
  Finland = 10000075,
  France = 10000076,
  Germany = 10000083,
  Hungary = 10000100,
  India = 10000102,
  Italy = 10000109,
  Luxembourg = 10000129,
  Netherlands = 10000155,
  Norway = 10000165,
  Poland = 10000176,
  Portugal = 10000177,
  Romania = 10000181,
  Serbia = 10000196,
  Slovakia = 10000200,
  Spain = 10000207,
  Sweden = 10000213,
  Switzerland = 10000214,
  'United Kingdom' = 10000233,
  'United States of America' = 10000234,
}
